<template>
  <div class="home">
    <h2>Welcome to Fission!</h2>
    <p>Fission is a function as a service (FaaS) runtime running on kubernetes.</p>
    <p>With this application, you can define new environments and develop functions.</p>
    <p>Have a nice and productive experience :)</p>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Home'
}
</script>
